// extracted by mini-css-extract-plugin
module.exports = {"brandSliderWrapper":"Gallery_brandSliderWrapper__20GE_","finished":"Gallery_finished__HzhS9","slick-arrow":"Gallery_slick-arrow__3tpU7"};